
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':site.isMigrationActive}">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select site design steps:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center site-design-step-selection-form">
    <div class="col-md-8 card-block">
      <div class="row">
        <div class="form-group col-lg-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="syncCdfDdl" [(ngModel)]="syncCdfDdl" (ngModelChange)="setFlag(&quot;syncCdfDdl&quot;)" autoLinkToLabel>
            <label class="form-check-label"> Allow
              <role-block class="inline-role-block" [roles]="['discovery-design-lead']"></role-block> to<b> synchronize CDF data</b>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="syncCdfTl" [(ngModel)]="syncCdfTl" (ngModelChange)="setFlag(&quot;syncCdfTl&quot;)" autoLinkToLabel>
            <label class="form-check-label"> Allow
              <role-block class="inline-role-block" [roles]="['transition-lead']"></role-block> to<b> synchronize CDF data</b>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="addIndividualAssetsDdl" [(ngModel)]="addIndividualAssetsDdl" (ngModelChange)="setFlag(&quot;addIndividualAssetsDdl&quot;)" autoLinkToLabel>
            <label class="form-check-label"> Allow
              <role-block class="inline-role-block" [roles]="['discovery-design-lead']"></role-block> to<b> create individual assets</b>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="addIndividualAssetsTl" [(ngModel)]="addIndividualAssetsTl" (ngModelChange)="setFlag(&quot;addIndividualAssetsTl&quot;)" autoLinkToLabel>
            <label class="form-check-label"> Allow
              <role-block class="inline-role-block" [roles]="['transition-lead']"></role-block> to<b> create individual assets</b>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="manualSiteDesignDdl" [(ngModel)]="manualSiteDesignDdl" (ngModelChange)="setFlag(&quot;manualSiteDesignDdl&quot;)" autoLinkToLabel>
            <label class="form-check-label"> Allow
              <role-block class="inline-role-block" [roles]="['discovery-design-lead']"></role-block> to<b> do manual site design via Excel</b>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="manualSiteDesignTl" [(ngModel)]="manualSiteDesignTl" disabled="true" autoLinkToLabel>
            <label class="form-check-label"> Allow
              <role-block class="inline-role-block" [roles]="['transition-lead']"></role-block> to<b> do manual site design via Excel</b>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>